module.exports = __webpack_public_path__ + "static/media/sueddeutsche_zeitung.4c374a4c.jpg";